export const PREFECTURES = [
  { code: '01', name: '北海道' },
  { code: '02', name: '青森県' },
  { code: '03', name: '岩手県' },
  { code: '04', name: '宮城県' },
  { code: '05', name: '秋田県' },
  { code: '06', name: '山形県' },
  { code: '07', name: '福島県' },
  { code: '08', name: '茨城県' },
  { code: '09', name: '栃木県' },
  { code: '10', name: '群馬県' },
  { code: '11', name: '埼玉県' },
  { code: '12', name: '千葉県' },
  { code: '13', name: '東京都' },
  { code: '14', name: '神奈川県' },
  { code: '15', name: '新潟県' },
  { code: '16', name: '富山県' },
  { code: '17', name: '石川県' },
  { code: '18', name: '福井県' },
  { code: '19', name: '山梨県' },
  { code: '20', name: '長野県' },
  { code: '21', name: '岐阜県' },
  { code: '22', name: '静岡県' },
  { code: '23', name: '愛知県' },
  { code: '24', name: '三重県' },
  { code: '25', name: '滋賀県' },
  { code: '26', name: '京都府' },
  { code: '27', name: '大阪府' },
  { code: '28', name: '兵庫県' },
  { code: '29', name: '奈良県' },
  { code: '30', name: '和歌山県' },
  { code: '31', name: '鳥取県' },
  { code: '32', name: '島根県' },
  { code: '33', name: '岡山県' },
  { code: '34', name: '広島県' },
  { code: '35', name: '山口県' },
  { code: '36', name: '徳島県' },
  { code: '37', name: '香川県' },
  { code: '38', name: '愛媛県' },
  { code: '39', name: '高知県' },
  { code: '40', name: '福岡県' },
  { code: '41', name: '佐賀県' },
  { code: '42', name: '長崎県' },
  { code: '43', name: '熊本県' },
  { code: '44', name: '大分県' },
  { code: '45', name: '宮崎県' },
  { code: '46', name: '鹿児島県' },
  { code: '47', name: '沖縄県' }
] as const;

// 不動産業種の定数（クライアント要望に基づく3つのカテゴリ）
export const REAL_ESTATE_JOB_TYPES = [
  { value: 'development', label: '不動産開発（デベロッパー、ハウスメーカー）' },
  { value: 'distribution', label: '不動産流通（仲介、販売代理）' },
  { value: 'management', label: '不動産管理（管理会社）' }
] as const;

// 企業タイプの定数
export const COMPANY_TYPES = [
  { value: 'major', label: '大手不動産会社' },
  { value: 'regional', label: '地域密着型' },
  { value: 'franchise', label: 'フランチャイズ' },
  { value: 'developer', label: 'デベロッパー' },
  { value: 'reit', label: 'REIT・ファンド' },
  { value: 'management', label: '管理会社' },
  { value: 'consulting', label: 'コンサルティング会社' },
  { value: 'tech', label: 'プロップテック企業' },
  { value: 'startup', label: 'スタートアップ' },
  { value: 'independent', label: '独立系・個人事業' },
  { value: 'other', label: 'その他' }
] as const;

// よく使われる不動産関連資格
export const COMMON_REAL_ESTATE_QUALIFICATIONS = [
  '宅地建物取引士',
  '不動産鑑定士',
  'マンション管理士',
  '管理業務主任者',
  '一級建築士',
  '二級建築士',
  'ファイナンシャルプランナー（AFP）',
  'ファイナンシャルプランナー（CFP）',
  'FP技能士1級',
  'FP技能士2級',
  'FP技能士3級',
  '不動産コンサルティングマスター',
  '賃貸不動産経営管理士',
  '土地家屋調査士',
  '司法書士',
  '行政書士',
  '中小企業診断士',
  '簿記検定1級',
  '簿記検定2級',
  '簿記検定3級'
] as const;

// ヘルパー関数
export const getPrefectureName = (code: string): string => {
  const prefecture = PREFECTURES.find(p => p.code === code);
  return prefecture?.name || '';
};

export const getJobTypeName = (value: string): string => {
  const jobType = REAL_ESTATE_JOB_TYPES.find(j => j.value === value);
  return jobType?.label || '';
};

export const getCompanyTypeName = (value: string): string => {
  const companyType = COMPANY_TYPES.find(c => c.value === value);
  return companyType?.label || '';
}; 